import { db, FirebaseDocRefType } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { BrandType } from 'types/brand'

const BrandConverter = getConverter<BrandType>()

export const fetchBrand = (brandId: string): Promise<BrandType | undefined> => {
  return db
    .collection('brands')
    .doc(brandId)
    .withConverter(BrandConverter)
    .get()
    .then((snapshot) => {
      const data = snapshot.data()
      if (!data) {
        return data
      }
      data.brand_ref = snapshot.ref
      return data
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchBrands = (): Promise<BrandType[]> => {
  return db
    .collection('brands')
    .withConverter(BrandConverter)
    .orderBy('created_at', 'asc')
    .get()
    .then((snapshots) => {
      return snapshots.docs.map((snapshot) => {
        const data = snapshot.data() as BrandType
        data.brand_ref = snapshot.ref
        return data
      })
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}

export const setBrand = (ref: FirebaseDocRefType, brand: BrandType): Promise<void> => {
  return ref.set(brand, { merge: true })
}
